import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { SmtpConfigurationService } from 'src/app/services/common/SmtpConfigurationService';
import { SaEmailconfigHistoryComponent } from '../sa-emailconfig-history/sa-emailconfig-history.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sa-emailconfig-test',
  templateUrl: './sa-emailconfig-test.component.html',
  styleUrls: ['./sa-emailconfig-test.component.scss']
})
export class SaEmailconfigTestComponent implements OnInit {
 
  SMTPTestConnForm: UntypedFormGroup;
  subsmtpTestAsync: SubscriptionLike;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  @Input() public Content: any;
  IsTestConnSuccess :boolean = false;
  content:any

  constructor(   
    private readonly fb: UntypedFormBuilder,
    //private readonly alertify: AlertifyService,
    private readonly service: SmtpConfigurationService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private commonservice :CommonService

  ) { }

  ngOnDestroy(): void {
    if (this.subsmtpTestAsync)
      this.subsmtpTestAsync.unsubscribe();
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.Content.content.SMTPConfig != undefined && this.Content.content.SMTPConfig != null) {
      this.SMTPTestConnForm.get('SMTPConfig')?.setValue(this.Content.content.SMTPConfig);
    }
  }

  cancelTestConn(): void {
   // if(this.IsTestConnSuccess)
    this.modalRef.dismiss();
  }

  buildForm() {
    this.SMTPTestConnForm = this.fb.group({
      ToEmailID: [null, [Validators.required]],
      Subject: ['', [Validators.required]],
      Body: [''],
      SMTPConfig: this.fb.group({
        EmailConfigID: [null],
        EmailID: [null, []],
        EmailPwd: [null, []],
        EmailDisplayName: [null, []],
        EmailAccountTypeCode: [null, []],
        GSuiteFileID: [null, []],
        FileName: [null, []],
        FileExt: [null, []],
        MicrosoftTenantID: [null, []],
        MicrosoftClientID: [null, []],
        MicrosoftClientSecret: [null, []],
        SMTPHost: [null, []],
        SMTPPort: [null, []],
        SMTPSSL: [null, []],
        UserID: [null, []],
        EmailServerStatus: [false, []],
        LoggedUserID: [null, []],
        TempFileStoreID: [null, []]
      })
    })
  }

  testConn(): void {
    if (this.validateTestForm()) {
      this.subsmtpTestAsync = this.service.smtpTestAsync(this.SMTPTestConnForm.value).subscribe(
        res => {
          if (res.Status==0){
            this.IsTestConnSuccess = true            
            //this.alertify.successBaner(res.SuccessMessage);
            this.commonservice.SuccessBanner(res.Message);
            this.modalRef.close();
            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: res.Message } } });

          }
          else {
            this.IsTestConnSuccess = false
            if (res.Message){
              //let message = res.Message;
              $("#NAME").addClass("ng-touched ng-invalid validate-error");
              $("#NAME").removeClass("ng-untouched ng-valid");
              // res.errorList.forEach(element => {
              //   message += element +".<br/>";
              // });
            //this.commonservice.ErrorBanner(res.Message);
            this.commonservice.ValidationBanner(res.Message);
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: res.Message } } });             
            }
             // this.alertify.validationBaner(res.errorList);
             
          }
        },
        err => {
          //this.commonservice.ErrorBanner(err);
          this.commonservice.ValidationBanner(err);
          // this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: err } } });
         // this.alertify.errorBaner(err);
        });
    }
  }

  validateTestForm(): boolean {
    let isValid = true;
    var EmailPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");


    // if (!this.SMTPTestConnForm.valid) {
      let err="";

      if (this.SMTPTestConnForm.get('ToEmailID')?.errors?.required) {
        err+=("Please enter To <br>");
      }
      try {
        if (this.SMTPTestConnForm.get('ToEmailID')?.value != "" && this.SMTPTestConnForm.get('ToEmailID')?.value != null) {
          var emailto = this.SMTPTestConnForm.controls['ToEmailID'].value;
          if (emailto != null) { var emailtovalid = emailto.replaceAll(",", ";"); }
          var emailtoArr = emailtovalid.split(';');
          for (var i = 0; i < emailtoArr.length; i++) {
            let isvalidemail = this.commonservice.validateEmail(emailtoArr[i].trim())
            if (!isvalidemail) {
              err+=("Email address entered is invalid. Please select another email address to test the connection </br>");
              break;
            }
          }
        }
      }
      catch (ex) {

      }

      if (this.SMTPTestConnForm.get('Subject')?.errors?.required) {
        err+=("Please enter Subject <br>");
      }

      if (err && err.length > 0) {
        this.commonservice.ValidationBanner(err);
        // this.modalService.show(MessageBoxComponent, { data: { heading: 'Valiation Message(s)', content: { heading: '', description: err } } });
        isValid = false;
      }
   // }
    return isValid;
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }
      var emailToValidate = control.value.replaceAll(",", ";");
      var emailToArr = emailToValidate.split(";");
      let valid = true;
      for (var i = 0; i < emailToArr.length; i++) {
        if (!regex.test(emailToArr[i])) {
          valid = false;
          break;
        }
      }
      return valid ? null : error;
    }
  }
}
